module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0009-01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "center1"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('strong', [_vm._v("Wise advice from a character named Arnbi, whom you’ll meet soon enough:")])])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('em', [_c('strong', [_vm._v("Too bad, but “simple” is a square peg that seldom fits into the round hole that is our modern world.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fadff6c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Frontmatter.vue
// module id = 75
// module chunks = 0